import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { ICandidate, IServiceRequestCandidateParams } from "../types";
import { getCandidatesByServiceRequestId } from "../services/candidates";
import { useState } from "react";

export const SERVICE_REQUEST_CANDIDATES_QUERY_KEY = "serviceRequestCandidates";

export const useServiceRequestCandidates = (
  params: IServiceRequestCandidateParams
) => {
  const [candidates, setCandidates] = useState<ICandidate[] | undefined>([]);

  const { isLoading, isError, isSuccess, refetch } = useDataQuery<ICandidate[]>(
    SERVICE_REQUEST_CANDIDATES_QUERY_KEY,
    () => getCandidatesByServiceRequestId(params),
    {
      enabled: false,
      onSuccess: (data) => setCandidates(data),
    }
  );

  // this is just removing temporally for a quick removal without additional api request
  const removeCandidateFromList = (conversationId: number) =>
    setCandidates((prev) =>
      prev.filter((item) => item.conversationId !== conversationId)
    );

  // this is just removing temporally, the backend will handel the actual removal via legacy
  const removeUnreadIndicatorFromConversation = (conversationId: number) =>
    setCandidates((prev) =>
      prev.map((item) => {
        if (item.conversationId === conversationId) {
          item.unreadConversationCommentsCount = 0;
        }
        return item;
      })
    );

  return {
    candidates,
    isLoading,
    isError,
    isSuccess,
    refetch,
    removeCandidateFromList,
    removeUnreadIndicatorFromConversation,
  };
};
